import React from "react";
import InfinityWhite from "./InfinityWhite.gif"

const LoadingButton =({Load}) =>{
    return(<>
    {Load?<><div style={{gridTemplateColumns: "25%  50% 25%",height:"55px",position:"absolute",top:"0px",left:"0px",right:"0px",bottom:"0px"}} 
    className="  add-cursor">
        <div></div>
    <img className=" " style={{width:"50px",height:"50px",right:"20px"}} src={InfinityWhite} alt="InfinityWhite" />
    <div></div></div></>:""}
    
    </>)
}
export default LoadingButton;